var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5056 44.0726C35.4198 44.0726 44.2675 35.2249 44.2675 24.3107C44.2675 13.3965 35.4198 4.54883 24.5056 4.54883C13.5914 4.54883 4.74365 13.3965 4.74365 24.3107C4.74365 35.2249 13.5914 44.0726 24.5056 44.0726Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5053 30.0023C22.707 30.0023 21.2446 28.5398 21.2446 26.7415V21.8604C21.2446 20.062 22.707 18.5996 24.5053 18.5996C26.3037 18.5996 27.766 20.062 27.766 21.8604V26.7415C27.766 28.5398 26.3037 30.0023 24.5053 30.0023Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3466 27.2159C33.9514 32.3144 29.6828 36.3064 24.5052 36.3064C19.0509 36.3064 14.6243 31.8797 14.6243 26.4255V22.1964C14.6243 16.7421 19.0509 12.3154 24.5052 12.3154C29.6236 12.3154 33.8328 16.2085 34.3269 21.1885",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapIcon);
export default __webpack_public_path__ + "static/media/tap-icon.97e2dfa7d92f3c823f91b39f8955ba89.svg";
export { ForwardRef as ReactComponent };